var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"navbar-default navbar-static-side\">\n  <div class=\"sidebar-space\"></div>\n  <div class=\"sidebar-collapse\">\n    <h5>Utilities</h5>\n    <ul id=\"side-menu\" class=\"utilities nav\">\n      <li><a href=\"#/finder\"><span class=\"fa fa-key\"></span>Finder</a></li>\n      <li><a href=\"#/loader\"><span class=\"fa fa-sitemap\"></span>Collection Loader</a></li>\n    </ul>\n  </div>\n  <div class=\"sidebar-space\"></div>\n  <div class=\"sidebar-collapse\">\n    <h5>Models</h5>\n    <ul class=\"model-list nav\"></ul>\n  </div>\n  <div class=\"sidebar-space\"></div>\n  <div class=\"sidebar-collapse collection-list\">\n    <h5>Collections</h5>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}